/* src/app/job-signoff-artic/partials/job-signoff-artic-manager/job-signoff-artic-manager.component.scss */
/*# sourceMappingURL=job-signoff-artic-manager.component.css.map */
